import { DashboardAsset, DashboardData } from '../types/Dashboard'
import { BaseClient } from './BaseClient'
import { Result } from './Result'

export class DashboardClient {
    private baseClient: BaseClient

    constructor(baseClient: BaseClient) {
        this.baseClient = baseClient
    }

    async retrieveDashboardData(): Promise<Result<DashboardData>> {
        return this.baseClient.getOkP<DashboardData>('/api/dashboard')
    }

    async retrieveAssetDetail(assetId: number): Promise<Result<DashboardAsset>> {
        return this.baseClient.getOkP<DashboardAsset>(`/api/dashboard/asset/${assetId}`)
    }
}
